import PropTypes from 'prop-types';

import {findById, parseExcelReferences} from '@modules/client/utils/thirdPartyTunnelHelper';
import {getYesOrNo} from '@utils/helpers';

export const exportExcel = (dataExport, clientId, vtdTunnels) => ({
    dataExport: dataExport,
    filename: `client_${clientId}_third_party_tunnels`,
    parseData: thirdPartyClientTunnels => [
        thirdPartyClientTunnels.id,
        thirdPartyClientTunnels.name,
        thirdPartyClientTunnels.description,
        getYesOrNo(thirdPartyClientTunnels.is_placeholder_for_auto_assignment),
        thirdPartyClientTunnels.vtd_tunnel_id ? findById(vtdTunnels, thirdPartyClientTunnels.vtd_tunnel_id)?.name : '',
        thirdPartyClientTunnels.vtd_tunnel_id ? (findById(vtdTunnels, thirdPartyClientTunnels.vtd_tunnel_id)?.started ? 'Started' : 'Stopped') : '',
        thirdPartyClientTunnels.encoding_job_profile.name,
        parseExcelReferences(thirdPartyClientTunnels.output_references),
    ],
    path: 'clients.products.thirdParty.tunnels.index.path',
    titles: [
        'ID',
        'Name',
        'Description',
        'Placeholder for auto-assignment',
        'VTD tunnel',
        'VTD tunnel status',
        'Encoding job profile',
        'Output client reference',
    ],
});

exportExcel.propTypes = {
    dataExport: PropTypes.array.isRequired,
    clientId: PropTypes.number.isRequired,
    vtdTunnels: PropTypes.array.isRequired,
};
